// Styles
import "../sass/main.scss";

// Images.
import "../img/tex1.png";
import "../img/tex2.png";
import "../img/tex3.png";
import "../img/lunivers-small.svg";
import "../img/lunivers_symbole_gradient.svg";
// import "../img/background1.svg";
// import "../img/background2.svg";
import "../img/bg_most.jpg";

// Scripts.

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

var body = document.body;

body.classList.add("colorscheme-" + (getRandomInt(4) + 1));

/*

import * as THREE from 'three';
import { SVGLoader } from '../../node_modules/three/examples/jsm/loaders/SVGLoader.js'

let camera, scene, renderer, parameters, wrap, bg_scene, bg_camera, bg_texture, i, bg_mesh, bg_light;
let mouseX = 0, mouseY = 0;
let mouse = {
        x: 0,
        y: 0,
        cameraX: 0,
        cameraY: 0
    },
    center = {
        x: 0,
        y: 0
    };

let windowHalfX = window.innerWidth / 2;
let windowHalfY = window.innerHeight / 2;

center.x = windowHalfX;
center.y = windowHalfY;

const materials = [];

init();
animate();

function init() {

    const manager = new THREE.LoadingManager()

    manager.onStart = function (item, loaded, total) {
        // console.log('Loading started')
    }

    manager.onProgress = function (item, loaded, total) {
        // console.log(item, loaded, total)
        // console.log('Loaded:', Math.round((loaded / total) * 100, 2) + '%')
        // bar.animate(1.0)
        //
    }

    manager.onLoad = function () {
        // console.log('Loading complete', comp.scene.render)
        // bar.destroy()
        // comp.animateOnScroll()
        // alert("BAM !");

        const login = document.querySelector('#login');
        const logo = document.querySelector('h1');
        document.body.classList.add("page-loaded");
        login.classList.add('animate__animated', 'animate__fadeInUp');
        logo.classList.add('animate__animated', 'animate__fadeIn', 'animate__delay-1s', "animate__slow");
    }

    manager.onError = function (url) {
        // console.log('Error loading')
    }

    camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 3000 );
    camera.position.z = 1000;

    scene = new THREE.Scene();
    scene.fog = new THREE.FogExp2( 10842, 0.001 );
    
    wrap = new THREE.Group,
    scene.add(wrap);

    const geometry = new THREE.BufferGeometry();
    const vertices = [];

    const textureLoader = new THREE.TextureLoader(manager);

    const sprite1 = textureLoader.load( Theme_Variables.templateUrl +'/wp-content/plugins/lunivers-admin/assets/build/src/img/tex1.png' );
    const sprite2 = textureLoader.load( Theme_Variables.templateUrl +'/wp-content/plugins/lunivers-admin/assets/build/src/img/tex2.png' );
    const sprite3 = textureLoader.load( Theme_Variables.templateUrl +'/wp-content/plugins/lunivers-admin/assets/build/src/img/tex3.png' );

    for ( let i = 0; i < 30; i ++ ) {

        const x = Math.random() * 2000 - 1000;
        const y = Math.random() * 2000 - 1000;
        const z = Math.random() * 2000 - 1000;

        vertices.push( x, y, z );

    }

    geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );

    parameters = [
        [[ 1.0, 0.2, 0.5 ], sprite1, .3 ],
        [[ 0.95, 0.1, 0.5 ], sprite2, .3 ],
        [[ 0.90, 0.05, 0.5 ], sprite3, .3 ],
        [[ 0.85, 0, 0.5 ], sprite1, .15 ],
        [[ 0.80, 0, 0.5 ], sprite2, .15 ]
    ];

    for ( let i = 0; i < parameters.length; i ++ ) {

        const color = parameters[ i ][ 0 ];
        const sprite = parameters[ i ][ 1 ];
        const size = parameters[ i ][ 2 ];

        materials[ i ] = new THREE.PointsMaterial( { 
            size: 100 * size, 
            map: sprite, 
            blending: THREE.AdditiveBlending, 
            depthTest: false, 
            transparent: true 
        } );
        //materials[ i ].color.setHSL( color[ 0 ], color[ 1 ], color[ 2 ] );

        const particles = new THREE.Points( geometry, materials[ i ] );

        // particles.rotation.x = Math.random(-180, 180) * Math.PI/180;
        // particles.rotation.y = Math.random(-180, 180) * Math.PI/180;
        // particles.rotation.z = Math.random(-180, 180) * Math.PI/180;
        
        particles.rotation.x = Math.random(-180, 180) * 6;
        particles.rotation.y = Math.random(-180, 180) * 6;
        particles.rotation.z = Math.random(-180, 180) * 6;

        scene.add( particles );
        //wrap.add(particles);

    }

    const loader = new SVGLoader(manager)
    const greatLogo = new THREE.Group()

    loader.load(Theme_Variables.templateUrl +'/wp-content/plugins/lunivers-admin/assets/build/src/img/lunivers-small.svg', function (data) {
        const paths = data.paths
        // console.log('paths', paths)
        // greatLogo = new THREE.Group()
        greatLogo.scale.multiplyScalar(3.25)
        greatLogo.position.x = -490
        greatLogo.position.y = 490
        greatLogo.position.z = 0
        greatLogo.scale.y *= -1

        for (let i = 0; i < paths.length; i++) {
            const path = paths[i]

            // const fillColor = path.userData.style.fill
            const strokeColor = '#fff' // path.userData.style.stroke
            const strokeOpacity = '0.2' // path.userData.style.strokeOpacity
            // console.log('style', path.userData.style)

            if (strokeColor !== undefined && strokeColor !== 'none') {
            const material = new THREE.MeshBasicMaterial({
                color: new THREE.Color().setStyle(strokeColor),
                opacity: strokeOpacity,
                transparent: strokeOpacity < 1,
                side: THREE.DoubleSide,
                depthWrite: false,
                wireframe: false,
            })
            for (let j = 0, jl = path.subPaths.length; j < jl; j++) {
                const subPath = path.subPaths[j]

                const geometry = SVGLoader.pointsToStroke(
                subPath.getPoints(),
                path.userData.style
                )

                if (geometry) {
                    const mesh = new THREE.Mesh(geometry, material)

                    greatLogo.add(mesh)
                }
            }
            }
        }
        // console.log(group)
        scene.add(greatLogo)
    })

    //
    
    document.body.style.touchAction = 'none';
    document.body.addEventListener( 'pointermove', onPointerMove, false );

    renderer = new THREE.WebGLRenderer({
        alpha: !1,
        antialias: !1,
        precision: "lowp"
    });
    renderer.setPixelRatio( window.devicePixelRatio );
    renderer.setSize( window.innerWidth, window.innerHeight );
    renderer.setClearColor(10842, 1);


    // Step 2
    bg_scene = new THREE.Scene;
    bg_camera = new THREE.Camera;
    //camera = new THREE.PerspectiveCamera(75,window.innerWidth / window.innerHeight,.1,1000);
    //camera.position.z = 0;
    // bg_texture = THREE.ImageUtils.loadTexture(Theme_Variables.templateUrl +"/wp-content/plugins/lunivers-admin/assets/img/bg_most.jpg", {});
    bg_texture = new THREE.TextureLoader(manager).load(Theme_Variables.templateUrl +"/wp-content/plugins/lunivers-admin/assets/build/src/img/bg_most.jpg")
    i = new THREE.MeshLambertMaterial({
        map: bg_texture
    });
    bg_mesh = new THREE.Mesh(new THREE.PlaneGeometry(2,2,0),i);
    bg_mesh.material.depthTest = !1;
    bg_mesh.material.depthWrite = !1;
    bg_scene.add(bg_camera);
    bg_scene.add(bg_mesh);
    bg_light = new THREE.SpotLight(16777215,2,100,Math.PI / 6,.4);
    bg_scene.add(bg_light);

    document.body.appendChild( renderer.domElement );

    //

    window.addEventListener( 'resize', onWindowResize, false );

}

function onWindowResize() {

    windowHalfX = window.innerWidth / 2;
    windowHalfY = window.innerHeight / 2;
    
    center.x = windowHalfX,
    center.y = windowHalfY,

    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();

    renderer.setSize( window.innerWidth, window.innerHeight );

}

function onPointerMove( event ) {

    if ( event.isPrimary === false ) return;

    // mouseX = event.clientX - windowHalfX;
    // mouseY = event.clientY - windowHalfY;
    mouse.x = (event.clientX - center.x) / center.x,
    mouse.y = (event.clientY - center.y) / center.y,
    //console.log([mouse.y, mouse.x]);
    mouse.cameraX = 200 * mouse.x,
    mouse.cameraY = 100 * mouse.y,
    mouse.lightX = -mouse.x,
    mouse.lightY = mouse.y

}

//

function animate() {

    requestAnimationFrame( animate );

    render();

}

function render() {

    const time = Date.now() * 0.00005;
    
    renderer.autoClear = !1;
    renderer.clear();
    bg_light.position.copy(new THREE.Vector3(mouse.lightX,mouse.lightY,3));
    renderer.render(bg_scene, bg_camera);

    camera.position.x += .05 * (mouse.cameraX - camera.position.x);
    camera.position.y += .05 * (-mouse.cameraY - camera.position.y);

    camera.lookAt( wrap.position );

    for ( let i = 0; i < scene.children.length; i ++ ) {

        const object = scene.children[ i ];

        if ( object instanceof THREE.Points ) {

            object.rotation.y = time * ( i < 4 ? i + 1 : - ( i + 1 ) );

        }

    }

    for ( let i = 0; i < materials.length; i ++ ) {

        const color = parameters[ i ][ 0 ];

        const h = ( 360 * ( color[ 0 ] + time ) % 360 ) / 360;
        materials[ i ].color.setHSL( h, color[ 1 ], color[ 2 ] );

    }

    renderer.render( scene, camera );

}

*/
